import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function Modal({ open, onClose, title, children, footer }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="sarnia-modal-overlay" onClick={onClose}>
      <div className="sarnia-modal" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="sarnia-modal__header">
          <h2 className="sarnia-modal__title">{title}</h2>
          <button className="sarnia-modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="sarnia-modal__body">{children}</div>
        {footer ? <div className="sarnia-modal__footer">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
}
